export default __webpack_public_path__ + "static/2023_2024_WVS INDIA GENERAL ACCOUNTS-a92e09256e4e4f12333d7193986ef73a.pdf";